/** Firestore writes for /parking_reports */
import {
  collection,
  addDoc,
  serverTimestamp,
  query,
  where,
  orderBy,
  getDocs,
  limit,
} from 'firebase/firestore';
import { db } from './firebase';
import type { ReportType, ParkingReport } from '../types';

const REPORTS = 'parking_reports';

interface SubmitReportArgs {
  parkingId: string;
  userId: string;
  reportType: ReportType;
  reportedHeightM?: number;
  notes?: string;
}

export async function submitReport(args: SubmitReportArgs): Promise<string> {
  const ref = await addDoc(collection(db, REPORTS), {
    parkingId: args.parkingId,
    userId: args.userId,
    reportType: args.reportType,
    reportedHeightM: args.reportedHeightM ?? null,
    notes: args.notes ?? null,
    createdAt: Date.now(),
    serverCreatedAt: serverTimestamp(),
  });
  return ref.id;
}

export async function fetchRecentReports(parkingId: string, max = 10): Promise<ParkingReport[]> {
  const q = query(
    collection(db, REPORTS),
    where('parkingId', '==', parkingId),
    orderBy('createdAt', 'desc'),
    limit(max)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const data = d.data();
    return {
      id: d.id,
      parkingId: data.parkingId,
      userId: data.userId,
      reportType: data.reportType,
      reportedHeightM: data.reportedHeightM ?? undefined,
      photoUrl: data.photoUrl ?? undefined,
      ocrExtractedValue: data.ocrExtractedValue ?? undefined,
      notes: data.notes ?? undefined,
      createdAt: data.createdAt ?? Date.now(),
    } as ParkingReport;
  });
}
